import {
  STOCK_TAKING_CAR_MANAGMENT_UPDATE_STATE_MACHINE_BEGIN,
  STOCK_TAKING_CAR_MANAGMENT_UPDATE_STATE_MACHINE_FAILURE,
  STOCK_TAKING_CAR_MANAGMENT_UPDATE_STATE_MACHINE_SUCCESS
} from '../constants'

export function reducer(state, action) {
  switch (action.type) {
    case STOCK_TAKING_CAR_MANAGMENT_UPDATE_STATE_MACHINE_BEGIN:
      return {
        takingCarManagement: {
          ...state.takingCarManagement,
          saveStatePending: true,
          saveStateSuccess: false,
          saveStateError: null
        }
      }
    case STOCK_TAKING_CAR_MANAGMENT_UPDATE_STATE_MACHINE_SUCCESS:
      return {
        takingCarManagement: {
          ...state.takingCarManagement,
          dataStateMachine: action.data,
          saveStatePending: false,
          saveStateSuccess: true,
          saveStateError: null
        }
      }
    case STOCK_TAKING_CAR_MANAGMENT_UPDATE_STATE_MACHINE_FAILURE:
      return {
        takingCarManagement: {
          ...state.takingCarManagement,
          saveStatePending: false,
          saveStateSuccess: false,
          saveStateError: action.data
        }
      }
    default:
      return state
  }
}
